import { useRef, useEffect } from "react";

/**
 * This utility allows us to get the previous value of a prop or state
 * when we are working with functional component and we don't have access
 * to the lifecycle methods like a class component.
 */
export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}